import {
	ADD_A_RURAL_DEFINITION_FILTER_OPTION,
	CHANGE_RURAL_DEFINITION_ACTION,
	INITIALIZE_CARTO_LAYERS_FROM_URL,
	REMOVE_A_RURAL_DEFINITION_FILTER_OPTION,
} from '../Actions/mapboxLayersActions'

import RURAL_DEFINITION from '../../content/rural-definition/rural-definition'

export const DEFAULT_RURAL_DEFINITION = RURAL_DEFINITION.rural_by_state_usda // TODO: probably should be specified in defaults/yaml

const DEFAULT_STATE = {
	selectedRuralDefinition: DEFAULT_RURAL_DEFINITION.cartoLayerId,
	selectedFilterOptionIndexesForEachRuralDefinition: Object.values(RURAL_DEFINITION)
		.reduce((defaultSelectedFilterOptions, {cartoLayerId, defaultFilterOptionsArrayIndex}) => {
			defaultSelectedFilterOptions[cartoLayerId] = defaultFilterOptionsArrayIndex
			return defaultSelectedFilterOptions
		}, {})
	// Format: { [cartoLayerId]: [0,1,2] } <-- index of filter values in definition.allFilterOptions
}

export default (state = DEFAULT_STATE, action) => {
	const { newSelectedRuralDefinition, newFilterOptionIndex, removedFilterOptionIndex, mapboxLayersFromURL } = action
	
	const {selectedRuralDefinition, selectedFilterOptionIndexesForEachRuralDefinition} = state
	const existingFilterOptionIndexes = selectedFilterOptionIndexesForEachRuralDefinition[selectedRuralDefinition]
	
	switch (action.type) {
		case CHANGE_RURAL_DEFINITION_ACTION:
			const newState = {
				...state,
				selectedRuralDefinition: newSelectedRuralDefinition,
			}
			return newState
		case ADD_A_RURAL_DEFINITION_FILTER_OPTION:
			return {
				...state,
				selectedFilterOptionIndexesForEachRuralDefinition: {
					...selectedFilterOptionIndexesForEachRuralDefinition,
					[selectedRuralDefinition]: [...(existingFilterOptionIndexes || []), newFilterOptionIndex],
				},
			}
		case REMOVE_A_RURAL_DEFINITION_FILTER_OPTION:
			return {
				...state,
				selectedFilterOptionIndexesForEachRuralDefinition: {
					...selectedFilterOptionIndexesForEachRuralDefinition,
					[selectedRuralDefinition]: (existingFilterOptionIndexes || []).filter(filterOption => filterOption !== removedFilterOptionIndex),
				},
			}
		case INITIALIZE_CARTO_LAYERS_FROM_URL:
			return {
				...state,
				...mapboxLayersFromURL,
				selectedFilterOptionIndexesForEachRuralDefinition: {
					...state.selectedFilterOptionIndexesForEachRuralDefinition,
					...mapboxLayersFromURL.selectedFilterOptionIndexesForEachRuralDefinition,
				}
			}
		default:
			return state
	}
}
